module.exports = __webpack_public_path__ + "img/cxample_09.28dd6531.png";